import { environment } from '../../../environments/environment';

/**
 * Convierte `foto` del API en URL absoluta para `<img>` / `tec-avatar` / `tagImage.img`.
 * Rutas relativas se resuelven contra `environment.apiUrl`.
 */
export function resolveUserFotoUrl(foto: string | null | undefined): string | null {
  const t = (foto ?? '').trim();
  if (!t) return null;
  if (/^https?:\/\//i.test(t) || t.startsWith('data:') || t.startsWith('blob:')) {
    return t;
  }
  const base = environment.apiUrl.replace(/\/$/, '');
  const path = t.startsWith('/') ? t : `/${t}`;
  return `${base}${path}`;
}
